/**
 * product-essentials-sold.js
 * Formulaire d'alerte inline du bloc « Ce vélo a été vendu » (buybox, fiche produit
 * vendue, parcours standard) — refonte OOS 2026-09-21, ticket 869f45dnt.
 * Markup : snippets/product-essentials-sold.liquid.
 *
 * Le formulaire ne crée PAS l'alerte lui-même : à la soumission il pré-remplit la
 * modale « Alerte site » (x-modal `alerte-modal`, custom element <alerte-site-modal>,
 * assets/alerte-site-modal.js) avec l'email saisi et les critères du vélo posés en
 * data-sold-* sur la racine du bloc, puis l'ouvre. C'est la modale qui valide et
 * envoie au webhook n8n — un seul chemin d'envoi, une seule validation.
 *
 * ORDRE OBLIGATOIRE : `prefill()` AVANT `open()`. L'ouverture émet `modal-opened` de
 * façon synchrone (x-modal.js) ; la modale y charge ses filtres (1re ouverture) ou se
 * réinitialise (suivantes), et applique le pré-remplissage en FIN de ce traitement.
 * Un prefill posé après open() ne serait consommé qu'à l'ouverture suivante.
 *
 * Repli : sans x-modal (script absent) on laisse partir le GET natif du <form>
 * (`/?modal=true&id=x-button__alerte-modal&email=…`), que x-modal.js sait ouvrir depuis
 * l'URL au chargement suivant. Sans <alerte-site-modal> ou sans sa méthode `prefill`
 * (version antérieure du script), la modale s'ouvre simplement vide.
 *
 * Edge connu : x-modal garde `isOpen = true` pendant les 300 ms de son animation de
 * fermeture — un re-submit dans cette fenêtre rend `open()` inerte, le prefill posé
 * sera consommé à l'ouverture suivante. Acceptable, non contourné.
 *
 * Tracking : rien ici. Le clic sur le bouton submit (souris, ou clic synthétique de la
 * soumission clavier) est capté par le délégué `.product-essentials-block [data-cta-name]`
 * de snippets/tracking-ecommerce.liquid.
 */
(function () {
  'use strict';
  if (window.__mbSoldBuyboxWired) return;
  window.__mbSoldBuyboxWired = true;

  document.addEventListener('submit', function (e) {
    var form = e.target && e.target.closest ? e.target.closest('[data-sold-alert-form]') : null;
    if (!form) return;

    var xModal = document.querySelector('x-modal[data-modal-id="alerte-modal"]');
    if (!xModal || typeof xModal.open !== 'function') return; // repli : GET natif

    e.preventDefault();

    var root = form.closest('.product-essentials-block--sold');
    var d = root ? root.dataset : {};
    var emailInput = form.querySelector('input[name="email"]');
    var alerte = xModal.querySelector('alerte-site-modal');

    if (alerte && typeof alerte.prefill === 'function') {
      alerte.prefill({
        email: emailInput ? emailInput.value.trim() : '',
        type: d.soldType || '',
        category: (d.soldCategory || '').split('|').filter(Boolean),
        marque: d.soldMarque || '',
        budgetMin: d.soldBudgetMin || '',
        budgetMax: d.soldBudgetMax || '',
        // Pas de taille : seul champ laissé à l'utilisateur (décision 2026-09-21).
      });
    }

    xModal.open();
  });
})();
